export default "__VITE_ASSET__DEu$WHri__"